import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { ProgramInputs } from "../../schemas/inputs";
import { RemoveVideoButton } from "../../styled";

interface VideoProps {
    index: number;
    register: UseFormRegister<ProgramInputs>;
    errors: FieldErrors<ProgramInputs>;
    removeVideo: (index: number) => void;
}

export const Video = ({ index, register, errors, removeVideo }: VideoProps) => {
    return (
        <Row className="p-0 program-video-row">
            <Col className="p-0">
                <Form.Group controlId={`youtubeLink_${index}`}>
                    <Form.Label>Link do vídeo {index + 1}</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder={`Digite o link do vídeo ${index}`}
                        {...register(`videos.${index}.url`)}
                        isInvalid={!!errors.videos?.[index]?.url}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.videos?.[index]?.url?.message}
                    </Form.Control.Feedback>
                </Form.Group>
            </Col>
            <Col>
                <Form.Group controlId={`youtubeName_${index}`}>
                    <div className="d-flex flex-column">
                        <div className="col">
                            <Form.Label>Nome do vídeo {index + 1}</Form.Label>
                        </div>
                        <div className="d-flex justify-content-center">
                            <div className="flex-fill">
                                <Form.Control
                                    type="text"
                                    placeholder={`Digite o nome do vídeo ${index}`}
                                    {...register(`videos.${index}.name`)}
                                    isInvalid={!!errors.videos?.[index]?.name}
                                />
                            </div>
                            <div className="d-flex">
                                <RemoveVideoButton onClick={() => removeVideo(index)}>
                                    <FontAwesomeIcon icon={['fas', 'close']} />
                                </RemoveVideoButton>
                            </div>
                        </div>
                    </div>
                    {errors.videos?.[index]?.name && (
                        <Form.Control.Feedback type="invalid" className="block">
                            {errors.videos?.[index]?.name?.message}
                        </Form.Control.Feedback>
                    )}
                </Form.Group>
            </Col>
        </Row>
    );
};
